import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // filters: { startDate, endDate, type, department, includeArchived }
    getReportData(ctx, filters = {}) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('getReportData', filters)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    // Same filters as getReportData; resolves with the PDF as a blob.
    downloadReportPdf(ctx, filters = {}) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('getReportPdf', filters, { responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
